<div class="container{{ isModal || fullWidth ? '-fluid' : '' }} border-secondary">
  <div class="row">
    <div class="col p-0">
      <ul ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false">
        @for (template of templatesToShow; track template; let index = $index) {
          <li ngbNavItem>
            <a ngbNavLink>{{ template.header }}</a>
            <ng-template ngbNavContent>
              <ng-template [ngTemplateOutlet]="template.template"> </ng-template>
            </ng-template>
          </li>
        }
      </ul>
      <div [ngbNavOutlet]="nav" class="bg-white p-3"></div>
    </div>
  </div>
</div>
